// Composable para gestión de datos de satélite inactivo con Composition API (Vue 2.7+)
import { ref, computed } from 'vue'
import axios from '../plugins/axios'
import moment from 'moment'

export function useSatelliteIna(satelliteName) {
  const satellite = ref(null)
  const packets = ref(null)
  const customTemplates = ref(null)
  const satvisFullScreen = ref(false)
  const viewerHost = process.env.VUE_APP_VIEWER_HOST

  const getSatellite = async () => {
    const { data } = await axios.get(`/v1/satelliteIna/${satelliteName}`)
    satellite.value = data
    document.title = `${satellite.value.displayName} satellite - TinyGS`
  }

  const getPackets = async () => {
    const { data } = await axios.get(`/v2/packetsIna?satellite=${satelliteName}`)
    customTemplates.value = data.templates
    packets.value = data.packets
  }

  const formatLaunchDate = (date) => moment(date).format('lll')

  const lastTelemetry = computed(() => {
    if (satellite.value && satellite.value.lastTelemetry)
      return { parsed: satellite.value.lastTelemetry }
    return null
  })

  return {
    satellite,
    packets,
    customTemplates,
    satvisFullScreen,
    viewerHost,
    getSatellite,
    getPackets,
    formatLaunchDate,
    lastTelemetry
  }
}